module.exports = __webpack_public_path__ + "img/logo.e525ffec.svg";